module.exports = __webpack_public_path__ + "static/img/bible_exhibition.d6e8feb.png";


//////////////////
// WEBPACK FOOTER
// ./src/common/pc/images/bible_exhibition.png
// module id = M1QH
// module chunks = 0